const SIZES_MAPPING = {
  1200: '1200x675',
  1120: '1120x630',
  720: '720x405',
  560: '560x315',
  272: '272x153',
  176: '176x99'
};

const PROD_IMAGE_PATH = 'https://cdn.nur.kz/images/';
const STAGE_IMAGE_PATH = 'https://cdn-s.nur.kz/images/';

const getImageUrl = (width, hash = '', format = 'jpeg', version = '', isProduction = true) => {
  const imageBasePath = isProduction ? PROD_IMAGE_PATH : STAGE_IMAGE_PATH;

  return `${imageBasePath}${SIZES_MAPPING[width]}/${hash}.${format}${version ? `?version=${version}` : ''} ${width}w`;
};

const getDefaultImageUrl = (width, hash = '', isProduction = true) => {
  const imageBasePath = isProduction ? PROD_IMAGE_PATH : STAGE_IMAGE_PATH;

  return `${imageBasePath}${SIZES_MAPPING[width]}/${hash}.jpeg`;
};

export const getImageProps = ({async, listOfWidths, sizes, coverImage}) => {
  const jpegImages = listOfWidths.map(size => getImageUrl(
    size,
    coverImage.hashKey, 'jpeg',
    coverImage.version,
    coverImage.isProduction
  )).join(', ');
  const webpImages = listOfWidths.map(size => getImageUrl(
    size,
    coverImage.hashKey,
    'webp',
    coverImage.version,
    coverImage.isProduction
  ))
    .join(', ');

  return ({
    sizes,
    src: getDefaultImageUrl(listOfWidths[0], coverImage.hashKey, coverImage.isProduction),
    alt: coverImage.alt,
    srcset: {
      jpeg: jpegImages,
      webp: webpImages
    },
    async
  });
};
